import React, {Component} from "react";
import axios from "axios";
import {createRoot} from 'react-dom/client';
import {Box, Container, Typography} from "@mui/material";

import Grid from "../components/Grid/Grid";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import PhotoViewer from "../components/PhotoViewer/PhotoViewer";

import Common from "../utils/common";
import ConfigurationHelper from "../configuration/ClientConfigurationHelper";

import ThemeProviderWrapper from "../hoc/ThemeProviderWrapper";

import theme from "../../sass/variables.json";
import "../../sass/_document.scss";

const {asset} = TVSite.channelVideosData;

class Photo extends Component {
    state = {
        breadcrumbsList: [],
        ambassador: null,
        apiUrl: null,
        totalVideos: 0,
    };
    componentDidMount() {
        Common.setCustomCookie(TVSite?.channelVideosData?.asset?.owner);
    }
    fetchAssets = async ({ page, filters }) => {
        const { creator_id } = filters;
        let filter = '{attribute:{code: "show_on_grid" , value: "yes"}}';
        if (creator_id) {
            filter = `{attribute:{code: "show_on_storefront" , value: "yes"}}, {creator_id: ${creator_id}}`;
        }
        const requestQuery = `{
            content(page: ${page}, per_page: 12, filter: {AND: [${filter}]}) {
                total
                items {
                    content_id
                    title
                    page_url
                    description
                    creator {
                        creator_id
                        employee_id
                        uri_stem
                        thumbnail
                        first_name
                        full_name
                        last_name
                        region {
                            name
                        }
                        store {
                            name
                            store_number
                        }
                    }
                    products {
                        product_id
                        image
                        price
                        sale_price
                        title
                        link
                    }
                    attributes {
                        code
                        value
                    }
                    content_type
                    creation_date
                    asset {
                        asset_type
                        video {
                            thumbnails {
                                width
                                height
                                url
                            }
                        }
                        photo {
                            thumbnails {
                                url
                                width
                                height
                            }
                        }
                    }
                }
            }
        }`;
        const apiUrl = ConfigurationHelper.getContentSearchUrl();
        const response = await axios.post(
            apiUrl,
            { query: requestQuery },
            { withCredentials: true }
        );
        this.setState({ totalVideos: response.data.data.content.total });
        return response.data.data.content.items.map((item) => {
            const attribute = item.attributes?.find?.(
                (f) => f.code === "category"
            );
            const category = attribute?.value[0] || "";
            return {
                ...item,
                title: item.title,
                user_id: item?.creator?.creator_id,
                description: item.description,
                id: item.content_id,
                category: category,
                entityType: item.content_type === "video" ? 1 : 7,
                owner: item.creator,
            };
        });
    };
    render() {
        const { breadcrumbsList, totalVideos } = this.state;
        return (
            <div className="app-container-video">
                <div className={"document-body " + theme.hub_wrapper_css_class}>
                    <ThemeProviderWrapper>
                        <Container>
                            <Breadcrumbs
                                keepOnMobile
                                breadcrumbsList={breadcrumbsList}
                            />
                            <PhotoViewer
                                userTotalVideos={totalVideos}
                                photo={asset}
                                ambassador={
                                    TVSite?.channelVideosData?.asset?.owner
                                }
                            />
                            <Box pb={2}>
                                <Typography variant={"h4"}>
                                    More by {TVSite?.channelVideosData?.asset?.owner?.first_name}
                                </Typography>
                            </Box>
                        </Container>
                        <Grid
                            fetchAssets={this.fetchAssets.bind(this)}
                            filters={{ creator_id: TVSite?.channelVideosData?.asset?.owner?.id }}
                            gridItemProps={{
                                maxDescriptionLines: 2,
                                redirect: true,
                                lazyLoadingThumbnails: true,
                            }}
                            noResultsText="No photos found."
                        />
                    </ThemeProviderWrapper>
                </div>
            </div>
        );
    }
};

let root = null;
let isMounted = false;
const targetEl = document.getElementById("app-container");

function isPhotoRoute() {
    const subFolder = ConfigurationHelper.getGlobalConfiguration().sub_folder || '';
    const pathname = window.location.pathname.toLowerCase();
    // Ensure subFolder starts with / if present
    const prefix = subFolder ? (subFolder.startsWith('/') ? subFolder : '/' + subFolder) : '';
    // Allow rendering on localhost or site.<env>.tvpage.com (env = test|stage|app)
    const host = window.location.hostname;
    const envPattern = /^site\.(test|stage|app)\.tvpage\.com$/;
    const isAllowedHost = host === 'localhost' || envPattern.test(host);

    return pathname.startsWith(`${prefix}/p/`) || isAllowedHost;
}

function mountPhotoApp() {
    if (!isMounted && isPhotoRoute()) {
        if (targetEl) {
            root = createRoot(targetEl);
            root.render(<Photo/>);
            isMounted = true;
        }
    }
}

function unmountPhotoApp() {
    if (isMounted && root) {
        root.unmount();
        if (targetEl) targetEl.innerHTML = '';
        isMounted = false;
    }
}

function handleRouteChange() {
    if (isPhotoRoute()) {
        mountPhotoApp();
    } else {
        unmountPhotoApp();
    }
}

const _pushState = history.pushState;
history.pushState = function() {
    _pushState.apply(this, arguments);
    handleRouteChange();
};
const _replaceState = history.replaceState;
history.replaceState = function() {
    _replaceState.apply(this, arguments);
    handleRouteChange();
};

window.addEventListener('popstate', handleRouteChange);
window.addEventListener('hashchange', handleRouteChange);

// Initial mount if on photo route
if (isPhotoRoute()) {
    mountPhotoApp();
} else {
    unmountPhotoApp();
}
